import './create';
import './read';
import './feedback';
import './language-toggle';
import './inline-prompt/inline-prompt';

document.addEventListener('DOMContentLoaded', () => {
  makeExamplesInteractive();

  const dates = document.querySelectorAll<HTMLElement>('.utc-date')!;
  for (let date of dates) {
    date.innerText = new Date(date.innerText).toLocaleString(undefined, {
      month: '2-digit',
      day: '2-digit',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
});

function makeExamplesInteractive() {
  const examples = document.getElementsByClassName('intro-example');
  for (const example of examples) {
    example.addEventListener('click', (e: Event) => {
      const currentTarget = e.currentTarget as HTMLElement;

      const title =
        currentTarget.querySelector('.card-title')?.textContent ?? '';
      const titleInput = document.getElementById('Title') as HTMLInputElement;
      titleInput.value = title;

      const text = currentTarget.querySelector('.card-text')?.textContent ?? '';
      const textInput = document.getElementById(
        'StoryLine'
      ) as HTMLInputElement;
      textInput.value = text;

      titleInput.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
  }
}